// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ph-1";
export var messageSideRight = "_ph-2";
export var subscribeToBackInStockBubbleContainer = "_ph-0";